import React from 'react'

import clsx from 'clsx'

import Breadcrumb from 'components/Breadcrumb'
import { BreadcrumbItem } from 'components/Breadcrumb/Breadcrumb'
import { Container } from 'components/Grid'

import classes from './BreadcrumbBar.module.scss'

/** @type {import('./types').default} */
const BreadcrumbBar = ({ breadcrumbs = [], route }) => {
  const getengagementDestination = breadcrumbType => {
    if (!breadcrumbType) {
      if (route === 'reviews_listing') {
        return 'go-to_product_reviews'
      }

      if (route === 'serp_fulltext' || route === 'serp_fulltext_software') {
        return 'go-to_serp_fulltext'
      }
    }
    if (breadcrumbType === 'category' || route === 'serp_category') {
      return 'go-to_category_all-products'
    }
    return 'go-to_product_details'
  }

  const breadcrumbStructuredItems = breadcrumbs.map(({ label, url }) => ({
    name: label,
    path: url,
  }))

  return (
    <div className={clsx('BreadcrumbBar', classes.root)}>
      <Container className={classes.container}>
        {!!breadcrumbs.length && (
          <Breadcrumb className={classes.breadcrumb} structuredDataItems={breadcrumbStructuredItems}>
            {breadcrumbs.map((item, index) => {
              const isLast = index === breadcrumbs.length - 1
              return (
                <BreadcrumbItem
                  key={`${item.label}-${item.url || 'current'}`}
                  isDisabled={isLast}
                  action={getengagementDestination(item.type)}
                  href={item.url}
                  className={classes.breadcrumbItem}
                >
                  {item.label}
                </BreadcrumbItem>
              )
            })}
          </Breadcrumb>
        )}
      </Container>
    </div>
  )
}

export default BreadcrumbBar
